module.exports = __webpack_public_path__ + "assets/font/SourceHanSansKR-Normal-6e8f945d.ttf";